import { useLenis } from "lenis/vue";

export function useSmoothScroll() {
  const lenis = useLenis();

  function smoothScroll(e, href) {
    e.preventDefault();
    const target = href === "#hero" ? 0 : href;
    lenis.value?.scrollTo(target, { duration: 2 });
  }

  function handleAnchorClick(e, href) {
    if (href?.startsWith("#")) {
      smoothScroll(e, href);
    }
  }

  return { smoothScroll, handleAnchorClick };
}
